import AiChatHistoryPage from 'src/@core/components/chat-history/AiChatHistoryPage'
import { AI_CATEGORIES } from 'src/@core/components/chat-history'

const AndroidLocalChatGPTPage = () => (
  <AiChatHistoryPage category={AI_CATEGORIES.CHATGPT} title='ChatGPT' mode='android-local' />
)

export default AndroidLocalChatGPTPage
